import { render, staticRenderFns } from "./FullServiceAdministration.vue?vue&type=template&id=e680c996&scoped=true&"
import script from "./FullServiceAdministration.vue?vue&type=script&lang=js&"
export * from "./FullServiceAdministration.vue?vue&type=script&lang=js&"
import style0 from "./FullServiceAdministration.vue?vue&type=style&index=0&id=e680c996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e680c996",
  null
  
)

export default component.exports